import React, { useCallback } from 'react';
import classNames from 'classnames';
import { TestIds } from '../constants';
const OverflowWrapper = ({ children, className, tabIndex = 0, }) => (React.createElement("div", { className: className, tabIndex: tabIndex, "data-testid": TestIds.overflow }, children));
const ResponsiveContainer = ({ containerLayoutClassName, overlowWrapperClassName, hasOverflow, shouldOmitWrapperLayers, children, role, label, extraRootClass = '', ariaLive, tabIndex, }) => {
    const wrapWithOverflowWrapperIfNeeded = useCallback((reactChildren) => !shouldOmitWrapperLayers && hasOverflow ? (React.createElement(OverflowWrapper, { className: classNames(overlowWrapperClassName, extraRootClass), tabIndex: tabIndex }, reactChildren)) : (reactChildren), [
        extraRootClass,
        hasOverflow,
        overlowWrapperClassName,
        shouldOmitWrapperLayers,
        tabIndex,
    ]);
    return wrapWithOverflowWrapperIfNeeded(shouldOmitWrapperLayers ? (React.createElement(React.Fragment, null, children())) : (React.createElement("div", Object.assign({ className: hasOverflow
            ? containerLayoutClassName
            : classNames(containerLayoutClassName, extraRootClass), "data-testid": TestIds.content }, (role ? { role } : {}), (label ? { 'aria-label': label } : {}), (ariaLive ? { 'aria-live': ariaLive } : {})), children())));
};
export default ResponsiveContainer;
//# sourceMappingURL=ResponsiveContainer.js.map